/**
 * Live rule checks for team-invite password UI — must stay aligned with
 * `team-invite-password-schema.ts`.
 */

export type TeamInvitePasswordRuleKey = 'minLength' | 'uppercase' | 'digit' | 'special'

export type TeamInvitePasswordRuleChecks = Record<TeamInvitePasswordRuleKey, boolean>

export const TEAM_INVITE_PASSWORD_RULE_ORDER: readonly TeamInvitePasswordRuleKey[] = [
  'minLength',
  'uppercase',
  'digit',
  'special',
] as const

export const TEAM_INVITE_PASSWORD_RULE_LABELS: Record<TeamInvitePasswordRuleKey, string> = {
  minLength: 'At least 8 characters',
  uppercase: 'At least one letter',
  digit: 'At least one number',
  special: 'At least one special character',
}

/** Mirrors validation rules in `team-invite-password-schema.ts` for real-time indicators. */
export function evaluateTeamInvitePasswordRules(password: string): TeamInvitePasswordRuleChecks {
  return {
    minLength: password.length >= 8,
    uppercase: /[A-Za-z]/.test(password),
    digit: /\d/.test(password),
    special: /[^A-Za-z0-9]/.test(password),
  }
}

export function allTeamInvitePasswordRulesMet(checks: TeamInvitePasswordRuleChecks): boolean {
  return (
    checks.minLength && checks.uppercase && checks.digit && checks.special
  )
}
